import axios from 'axios';
import { IAM_API_BASE_URL_2, IAM_API_BASE_URL_3, ISC_BASE_URL, ORG_AUTH_URL } from './TapApiUrls';
import { toast } from 'react-toastify';
import TapHelper from './TapHelper';
import Cookies from 'js-cookie';



// Create axios instances for different API servers
export const authApi = axios.create({
    baseURL: ORG_AUTH_URL,
    withCredentials: false, // Important for HttpOnly cookies
    params :  {'source'            :   'web'}
});

export const server2Api = axios.create({
    baseURL: IAM_API_BASE_URL_3,
    withCredentials: false,
    params :  {'source'            :   'web'}
});

export const iscApi = axios.create({
    baseURL: ISC_BASE_URL,
    withCredentials: false,
    params :  {'source'            :   'web'}
});


export const server4Api = axios.create({
    baseURL: IAM_API_BASE_URL_2,
    withCredentials: false,
    params :  {'source'            :   'web'}
});


// Request interceptor to add headers
const addAuthHeader = (config) => {
    // Since we're using HttpOnly cookies, we don't need to manually add tokens
    // But we can add other headers if needed
    config.headers['Accept']        =   'application/json';
    config.headers['Content-Type']  =   'application/json';
    config.headers['X-Device-Id']   =    TapHelper.decrypt(TapHelper.cookiesGet("device_id"))
    return config;
};


// Response interceptor to handle errors
const handleResponseError = (error) => {
    if (error.message?.includes('canceled')) {
        return Promise.reject(error);
    }
    let msg                 =   error?.response?.data?.message ?? 'Application not initialize successfully.';
    
    if (error.response?.status === 401) {
        // Token expired or invalid
        // setTimeout(() => {
        //     window.location.href = "/logout";
        // }, 3000);
    }

    toast.error(error?.response?.data?.message ?? msg, {position: toast.POSITION.TOP_RIGHT});
    return Promise.reject(error);
};


// Add interceptors to all instances
[authApi, iscApi, server2Api, server4Api].forEach(apiInstance => {
    apiInstance.interceptors.request.use(addAuthHeader);
    apiInstance.interceptors.response.use(response => response, handleResponseError);
});

export default { authApi, iscApi, server2Api, server4Api };